/**
 * Linki w .dialog-buttons, które nie dostają globalnego zamknięcia modala (akcja główna w komponencie).
 * Rozszerzaj tę listę :not(...) przy nowych wyjątkach.
 */
const DIALOG_FOOTER_ANCHOR_AUTO_CLOSE =
    '.dialog-buttons > a:not(.js-accept-date-range):not(.js-accept-filter-type)';

const dialogManager = {
    openDialogId: null,
    boundClickHandlers: new WeakMap(),
    boundKeydownHandlers: new WeakMap(),
    dialogOriginalPlace: {},
    createButtonWrapper: function() {
        return '<div class="dialog-buttons"></div>'
    },
    createModalStructure: function(modalId, title, cssClass) {
        // Sprawdzenie czy modal o wskazanym id już istnieje
        if (document.getElementById(modalId)) return

        // Tworzenie modalu
        const modal = document.createElement('div');
        const ariaLabelledbyModal = `labelledby_component_${modalId}`;
        modal.className = `${cssClass} dialog-wrapper`;
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-hidden', 'true');
        modal.setAttribute('aria-labelledby',ariaLabelledbyModal);
        modal.id = modalId;

        // === HEADER ===
        const header = document.createElement('div');
        header.className = 'dialog-header';

        const h2 = document.createElement('h2');
        h2.textContent = title;
        h2.id = ariaLabelledbyModal;

        const closeBtn = document.createElement('button');
        closeBtn.className = 'dialog-close';
        closeBtn.setAttribute('aria-label', 'Zamknij');

        const closeIcon = document.createElement('span');
        closeIcon.className = 'web-icon icon-close';
        closeIcon.setAttribute('aria-hidden', 'true');
        closeBtn.appendChild(closeIcon);

        header.appendChild(h2);
        header.appendChild(closeBtn);

        // === CONTENT ===
        const content = document.createElement('div');
        content.className = 'dialog-content';

        // Składanie modalu
        modal.appendChild(header);
        modal.appendChild(content);
        return modal;
    },
    createAndRegisterModal: function(modalId, title, cssClass, parentElement) {
        // Tworzy modal, dodaje content i automatycznie dołącza do DOM
        const modal = this.createModalStructure(modalId, title, cssClass);
        if (!modal) return null;

        if (parentElement) {
            parentElement.appendChild(modal);
        }

        // Automatycznie zarejestruj w systemie (będzie działać z istniejącymi event handlerami)
        setTimeout(() => {
            this.init(); // Re-binduj eventy żeby nowy modal był rozpoznany
        }, 10);

        return modal;
    },
    initCover: () => {
        const cover = document.createElement('div');
        cover.classList.add('dialog-cover');
        document.body.appendChild(cover);
    },
    removeCover: () => {
        const cover = document.querySelector('.dialog-cover');
        if (cover) {
            cover.parentNode.removeChild(cover);
        }
    },
    blockBodyScroll: () => {
        const scrollWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.paddingRight = `${scrollWidth}px`;
        document.body.style.overflow = 'hidden';
    },

    removeBlockBodyScroll: () => {
        document.body.style.paddingRight = '';
        document.body.style.overflow = '';
    },
    createDialogContainer: () => {
        const outletContent = document.getElementById('outlet-content');
        if (!outletContent) return null;

        const container = document.createElement('div');
        container.className = 'dialog-container';
        outletContent.appendChild(container);

        return container;
    },
    moveDialogToContainer: modalId => {
        const dialog = document.getElementById(modalId);
        const container = dialogManager.createDialogContainer(modalId);

        if (dialog && container) {
            // Zapamiętuje gdzie był dialog wcześniej
            dialogManager.dialogOriginalPlace[modalId] = {
                parent: dialog.parentNode,
                nextSibling: dialog.nextSibling
            };

            // Zbieram elementy layoutu do ukrycia
            const layoutElements = [
                document.querySelector('.outlet-header'),
                document.querySelector('.outlet-footer'),
                ...document.querySelectorAll('#outlet-content > .layout_element')
            ].filter(Boolean);

            // Zapisuje ich stan + ukwywam
            dialogManager.hiddenLayoutElements = layoutElements;
            layoutElements.forEach(el => el.setAttribute('aria-hidden', 'true'));

            // Przenieś dialog
            container.appendChild(dialog);
        }
    },
    returnDialogToOriginalPlace: modalId => {
        const dialog = document.getElementById(modalId);
        const originalPlace = dialogManager.dialogOriginalPlace[modalId];

        if (dialog && originalPlace) {
            const wrapper = dialog.closest('.dialog-container');
            if (wrapper) {
                wrapper.remove();
            }

            // Przywracam aria-hidden false
            if (dialogManager.hiddenLayoutElements) {
                dialogManager.hiddenLayoutElements.forEach(el =>
                    el.setAttribute('aria-hidden', 'false')
                );
                delete dialogManager.hiddenLayoutElements;
            }

            // Wracam z dialogiem do domu
            originalPlace.parent.insertBefore(dialog, originalPlace.nextSibling);

            // Czyszczę zapisaną referencję
            delete dialogManager.dialogOriginalPlace[modalId];
        }
    },
    handleTabNavigation: (dialog) => {
        const keydownHandler = (e) => {
            if (e.key !== 'Tab') return;
            const focusableSelector = 'a[href], button, textarea, input, select, tbody[tabindex="0"], .dialog-content[tabindex="0"]';
            const isVisible = (el) => !!(el && el.offsetParent);
            const content = dialog.querySelector('.dialog-content');

            // widoczne focusowalne TYLKO w treści (bez przycisku zamknięcia z headera)
            const visibleInContent = Array
                .from(content.querySelectorAll(focusableSelector))
                .filter(isVisible);

            // jeśli w treści nie ma nic interesujacego dodaje fokus/scroll
            const hasScroll =
                content.scrollHeight > content.clientHeight ||
                content.scrollWidth  > content.clientWidth;

            if (visibleInContent.length === 0 && hasScroll) {
                content.tabIndex = 0;
            } else {
                content.removeAttribute('tabindex');
            }

            // Pełna lista elementów w dialogu (treść + "X" zamknięcia)
            const visibleAll = Array
                .from(dialog.querySelectorAll(focusableSelector))
                .filter(el => isVisible(el));

            if (!visibleAll.length) return;

            const first = visibleAll[0];
            const last  = visibleAll[visibleAll.length - 1];
            const active = document.activeElement;

            // prosty wrap na krawędziach
            const current = active.closest ? active.closest(focusableSelector) : null;
            const idx = visibleAll.indexOf(current);

            if (!e.shiftKey) {
                // TAB do przodu: jeśli jesteśmy na końcu, wróć na pierwszy
                if (idx === visibleAll.length - 1) {
                    e.preventDefault();
                    first.focus();
                }
            } else {
                // SHIFT+TAB: jeśli jesteśmy na początku, wróć na ostatni
                if (idx === 0) {
                    e.preventDefault();
                    last.focus();
                }
            }
        };

        dialog.addEventListener('keydown', keydownHandler);
        dialogManager.boundKeydownHandlers.set(dialog, keydownHandler);
    },

    removeTabNavigation: (dialog) => {
        const handler = dialogManager.boundKeydownHandlers.get(dialog);
        if (handler) {
            dialog.removeEventListener('keydown', handler);
            dialogManager.boundKeydownHandlers.delete(dialog);
        }
    },
    removeNestedHaspopup: (dialog) => {
        const triggersInside = dialog.querySelectorAll('[data-show="dialog"]');
        triggersInside.forEach(btn => {
            btn.removeAttribute('aria-haspopup');
        });
    },
    isMobile: () => rwd.ScreenSize.is(rwd.ScreenSize.SIZES.XSMALL)
        || rwd.ScreenSize.is(rwd.ScreenSize.SIZES.SMALL),
    updateDialogHeightWithFullScroll: (dialog) => {
        const dialogContent = dialog.querySelector('.dialog-content');

        // Reset stylów content
        dialogContent.style.height = '';
        dialogContent.style.maxHeight = '';

        // Dodanie klasy do całego dialogu
        dialog.classList.add('state-dialogFullScroll');
    },
    updateDialogHeight: (dialog) => {
        const dialogContent = dialog.querySelector('.dialog-content');
        const headerDialog = dialog.querySelector('.dialog-header');
        const buttonsArea = [...dialog.querySelectorAll('.dialog-buttons')].find(button => getComputedStyle(button).display !== 'none');
        const headerHeight = headerDialog?.clientHeight || 0;
        const buttonsHeight = buttonsArea?.clientHeight || 0;
        const areaNotContent = headerHeight + buttonsHeight;
        const marginSpace = 64;

        if (document.body.classList.contains('state-zoom300')) {
            dialogManager.updateDialogHeightWithFullScroll(dialog);
        } else {
            // Reset pełnego scrolla
            dialog.classList.remove('state-dialogFullScroll');

            if (dialogManager.isMobile()) {
                dialogContent.style.height = `calc(100% - ${areaNotContent}px)`;
                dialogContent.style.maxHeight = '';
            } else {
                dialogContent.style.height = '';
                dialogContent.style.maxHeight = `calc(100vh - ${areaNotContent + marginSpace}px)`;
            }
        }
    },
    handlePreviousDialog: (newDialog, currentDialogId, prevDialogId) => {
        dialogManager.closeDialog(prevDialogId);

        if (!newDialog.querySelector('.return-button')) {
            const returnButton = document.createElement('button');
            returnButton.classList.add('dialog-return', 'return-button');
            returnButton.setAttribute('aria-label', 'Powrót');
            returnButton.innerHTML = `<span class="web-icon icon-arrow-left" aria-hidden="true"></span>`;

            returnButton.addEventListener('click', () => {
                const prevDialog = document.getElementById(prevDialogId);

                // Szukam przycisku, który otworzył bieżący dialog
                const normalizedId = currentDialogId.replace(/^#/, '');

                const prevTriggerButton = prevDialog?.querySelector(
                    `[data-id-modal="${normalizedId}"], [data-id-modal="#${normalizedId}"], [href="#${normalizedId}"]`
                );


                dialogManager.closeDialog(currentDialogId);
                dialogManager.openDialog(prevDialogId);
                if (prevTriggerButton) {
                    prevTriggerButton.focus();
                }
            });
            newDialog.prepend(returnButton);
        }
    },

    initAndOpenDialog : (dialog, modalId, openDialogButton) => {
        dialogManager.openDialogId = modalId;
        dialog.classList.add('is-open');
        dialog.setAttribute('aria-hidden', 'false');
        dialogManager.blockBodyScroll();
        dialogManager.initCover();
        dialogManager.moveDialogToContainer(modalId);

        const returnButton = dialog.querySelector('.return-button');

        if (returnButton) {
            returnButton.focus();
        } else {
            if (!dialog.hasAttribute('tabindex')) {
                dialog.setAttribute('tabindex', '-1');
            }
            dialog.focus();
        }

        dialogManager.handleTabNavigation(dialog);
        dialogManager.updateDialogHeight(dialog);

        const dialogButtons = [
            ...dialog.querySelectorAll(`[class*="dialog-close"], ${DIALOG_FOOTER_ANCHOR_AUTO_CLOSE}`),
        ];
        const closeDialog = () => {
            dialogButtons.forEach(btn => btn.removeEventListener('click', closeDialog));
            dialogManager.closeDialog(modalId, openDialogButton);
        };
        dialogButtons.forEach(btn => btn.addEventListener('click', closeDialog));
        document.addEventListener('keydown', dialogManager.addESC);
    },
    openDialog: (modalId, openDialogButton) => {
        const dialog = document.getElementById(modalId);
        const prevDialogId = dialogManager.openDialogId;

        if (!dialog) return;

        if (dialog.classList.contains('dialog-wrapper--preview')) {
            dialog.classList.remove('dialog-wrapper--preview');
        }

        if (!dialogManager.openDialogButton) {
            dialogManager.openDialogButton = openDialogButton;
        }
        const firstDialogTriggerButton = dialogManager.openDialogButton;

        if (prevDialogId) {
            dialogManager.handlePreviousDialog(dialog, modalId, prevDialogId);
        }

        document.dispatchEvent(new CustomEvent('dialog-opened', {
            detail: { modalId }
        }));

        dialogManager.removeNestedHaspopup(dialog);
        dialogManager.initAndOpenDialog(dialog, modalId, firstDialogTriggerButton);
    },
    closeDialog: (modalId, openDialogButton = null) => {
        const dialog = document.getElementById(modalId);
        dialogManager.removeBlockBodyScroll();
        dialogManager.removeCover();
        dialogManager.returnDialogToOriginalPlace(modalId);
        dialogManager.openDialogId = null;
        dialogManager.openDialogButton = null;
        if (dialog) {
            dialogManager.removeTabNavigation(dialog);
            const returnButton = dialog.querySelector('.return-button');
            if (returnButton && openDialogButton) {
                returnButton.remove();
            }
            dialog.classList.remove('is-open');
            dialog.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('dialog-open');
            document.removeEventListener('keydown', dialogManager.addESC);
            if (openDialogButton) {
                openDialogButton.focus();
            }
        }
        document.dispatchEvent(new CustomEvent('dialog-closed', {
            detail: { modalId }
        }));
    },
    findOpenDialog: () => document.querySelector('[role="dialog"].is-open'),
    addESC: e => {
        if (e.key === 'Escape') {
            const dialog = dialogManager.findOpenDialog();
            if (dialog) {
                const closeButton = dialog.querySelector('.dialog-close');
                if (closeButton) {
                    closeButton.click();
                }
            }
        }
    },
    init: () => {
        const isUserPart = !ComponentsManager.isBuilder();
        if (!isUserPart) return;

        const dialogButtons = document.querySelectorAll('[data-show="dialog"]');
        dialogButtons.forEach(button => {
            const previousHandler = dialogManager.boundClickHandlers.get(button);
            if (previousHandler) {
                button.removeEventListener('click', previousHandler);
            }

            if (button.tagName === 'A') {
                button.setAttribute('role', 'button');
                button.setAttribute('aria-haspopup', 'dialog');
            }

            const clickHandler = event => {
                const target = event.currentTarget;
                event.preventDefault();
                event.stopPropagation();
                const modalId = target.getAttribute('data-id-modal') || target.getAttribute('href').replace('#', '');
                dialogManager.openDialog(modalId, button);
            };

            dialogManager.boundClickHandlers.set(button, clickHandler);
            button.addEventListener('click', clickHandler);
        });

        $(document).onPage(rwd.ScreenSize.RESIZE_EVENT_NAME, () => {
            const dialog = dialogManager.findOpenDialog();
            if (dialog) {
                dialogManager.updateDialogHeight(dialog);
            }
        });
    },
};

$("#outlet-content").on('content-replace', function() {
    if (document.querySelector('.dialog-cover')) {
        dialogManager.closeDialog();
    }

    if(ComponentsManager.isPreview()) {
        const dialogWrappers = document.querySelectorAll('.dialog-wrapper');
        dialogWrappers.forEach(wrapper => {
            wrapper.classList.add('dialog-wrapper--preview');
        });
    }

    setTimeout(() => {
        dialogManager.init(); // Inicjalizujemy dialog po 1 sekundzie, bo musimy poczekać na INGDS
    }, 1000);
});

const onExchangeRatesHtmlReplaced = () => {
    setTimeout(() => {
        dialogManager.init();
    }, 1000);
};

document.body.addEventListener('exchange-rates-element-html-replaced', onExchangeRatesHtmlReplaced);
document.body.addEventListener('exchange-rates-online-element-html-replaced', onExchangeRatesHtmlReplaced);
